module.exports = __webpack_public_path__ + "static/media/Еня 3.6ca5eac7.jpg";